<template>
  <div class="flex grow">
    <div class="flex flex-col gap-1">
      <CreateCardDetails
        v-if="actionType === actionTypes.create_card || actionType === actionTypes.update_card"
        class="suggested-action-details"
        :action-details="actionDetails"
        :action-type="actionType"
        :show-diff="showDiff"
        :expanded="expanded"
        :card-id="cardId"
      />
      <MoveCardDetails
        v-if="actionType === actionTypes.move_card"
        class="suggested-action-details"
        :action-details="actionDetails"
        :action-type="actionType"
        :card-id="cardId"
      />
      <div
        v-if="actionType === actionTypes.create_comment"
        class="suggested-action-details"
      >
        <div class="suggested-action-details-item">
          <div class="suggested-action-item-wrap">
            <span class="suggested-action-description">
              {{ actionDetails.content }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showDiff && !expanded"
      class="suggested-action-details-item ml-auto pl-1 flex items-center"
    >
      <em
        class="custom-icons flex w-4 h-4 bg-icon-default pt"
        :style="getCustomIconStyle(iconPath(chevronIcon))"
        @click="expanded = !expanded"
      ></em>
    </div>
  </div>
</template>

<script setup>
import useSuggestedActions from '@/utilities/composables/useSuggestedActions';
import { computed, ref } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import CreateCardDetails from '@/components/notes/CreateCardDetails.vue';
import MoveCardDetails from '@/components/notes/MoveCardDetails.vue';
const { actionTypes } = useSuggestedActions();

const { iconPath, getCustomIconStyle } = useCustomIcon();
const expanded = ref(false);

const props = defineProps({
  actionDetails: {
    type: Object,
    required: true,
  },
  actionType: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
    required: false,
    default: null,
  },
});

const chevronIcon = computed(() => {
  return expanded.value ? 'chevron-up' : 'chevron-down';
});

const showDiff = computed(() => {
  // there might be other types in the future
  return [actionTypes.update_card].includes(props.actionType);
});
</script>

<style lang="scss">
.suggested-action-details {
  @apply flex flex-col box-border gap-1;

  .suggested-action-details-item {
    @apply border-standard-border;

    .suggested-action-item-wrap {
      @apply flex gap-2 items-center;

      .suggested-action-item-title,
      .suggested-action-description {
        @apply text-sm;
      }

      .suggested-action-item-title {
        @apply text-text-default;
        &.line-through {
          @apply text-deEmphasised-text;
        }
      }

      .suggested-action-description {
        @apply text-text-default;
      }
    }
  }
}
</style>
